module.exports = __webpack_public_path__ + "img/Johor.0bd0e90f.png";